import UserService from 'aurora-composition/services/userService';
import OwnerService from 'aurora-composition/services/ownerService';
import * as types from './constants';

export const fetchProfileSuccess = user => ({
  type: types.FETCH_PROFILE_SUCCESS,
  payload: {
    user,
  },
});

export const fetchProfileFail = error => ({
  type: types.FETCH_PROFILE_ERROR,
  payload: {
    error,
  },
});

export const fetchProfile = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_PROFILE });
    const res = await UserService.fetchProfile();
    if (localStorage.getItem('userType') === 'profileSwitcher') {
      localStorage.setItem('UserNameEn', res?.customerNameEn);
      localStorage.setItem('UserNameAr', res?.customerNameAr);
      localStorage.setItem('firstNameEn', res?.customerNameEn);
      localStorage.setItem('firstNameAr', res?.customerNameAr);
      localStorage.setItem('UserNameBannerEn', res?.customerNameEn);
      localStorage.setItem('UserNameBannerAr', res?.customerNameAr);
    }
    dispatch(fetchProfileSuccess(res?.data || res));
  } catch (e) {
    dispatch(fetchProfileFail(e));
  }
};

// / edit email
export const editProfileSuccess = user => ({
  type: types.FETCH_PROFILE_SUCCESS,
  payload: {
    user,
  },
});

export const editEmailFail = error => ({
  type: types.FETCH_PROFILE_ERROR,
  payload: {
    error,
  },
});

export const editProfile = data => async dispatch => {
  try {
    dispatch({ type: types.EDIT_PROFILE });
    const res = await UserService.editProfile(data);

    dispatch(fetchProfileSuccess(res));
  } catch (e) {
    dispatch(fetchProfileFail(e));
  }
};

// switch profile

export const switchProfileSuccess = user => ({
  type: types.SWITCH_PROFILE_SUCCESS,
  payload: {
    user,
  },
});

export const switchProfileFail = error => ({
  type: types.SWITCH_PROFILE_ERROR,
  payload: {
    error,
  },
});

export const switchProfile = query => async dispatch => {
  try {
    dispatch({ type: types.SWITCH_PROFILE });
    const res = await UserService.switchProfile(query);
    const token = res?.access_token;
    localStorage.setItem('access_token', token);
    localStorage.setItem('refresh_token', res?.refresh_token);
    const resUser = await UserService.fetchProfile();
    if (localStorage.getItem('userType') === 'profileSwitcher') {
      localStorage.setItem('UserNameEn', resUser?.customerNameEn);
      localStorage.setItem('UserNameAr', resUser?.customerNameAr);
      localStorage.setItem('firstNameEn', resUser?.customerNameEn);
      localStorage.setItem('firstNameAr', resUser?.customerNameAr);
    }
    dispatch(switchProfileSuccess(res));
    return true;
  } catch (e) {
    dispatch(switchProfileFail(e));
    return false;
  }
};

export const fetchProfileLookUps = () => async dispatch => {
  try {
    const legalFormsResp = await OwnerService.fetchLegalForms();
    const licenseSourcesResp = await OwnerService.fetchLicenseSources();
    dispatch({
      type: types.FETCH_LOOKUP_PROFILE_SUCCESS,
      payload: { legalForms: legalFormsResp?.result?.legalForms, licenseSources: licenseSourcesResp?.result },
    });
    // dispatch(fetchProfileSuccess(res?.data || res));
  } catch (e) {
    console.log(e);
  }
};

export const downloadDocument = payload => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_DOCUMENT_LOADING });

    const downloadDoc = await UserService.downloadDocument(payload);
    const file = new Blob([downloadDoc], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    // window.open(fileURL);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', payload.name ?? new Date());
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_DOCUMENT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_DOCUMENT_ERROR, payload: { error } });
  }
};

export const fetchProfileEnabledServices = () => async dispatch => {
  try {
    const response = await OwnerService.fetchProfileEnabledServices();

    dispatch({ type: types.PERMISSION_SUCCESS, payload: response.result });
  } catch (error) {
    dispatch({ type: types.PERMISSION_ERROR, payload: { error } });
  }
};
